/** Medição de desempenho do item 3.2: resume os tempos de quadro de uma rodada de 10 s. */

export const BENCH_SECONDS = 10;
/** Tempo ignorado no começo (compilação de shaders e aquecimento), em ms. */
export const BENCH_WARMUP_MS = 1000;

export interface BenchResult {
  frames: number;
  /** Média de quadros por segundo. */
  avgFps: number;
  /** Fps do 1% de quadros mais lentos (o "engasgo" que o jogador sente). */
  low1Fps: number;
  /** Fração dos quadros que levaram mais de 1/50 s. */
  slowShare: number;
}

/** `frameMs`: duração de cada quadro em milissegundos, em ordem. */
export function summarizeFrames(frameMs: readonly number[]): BenchResult {
  let skipped = 0;
  let start = 0;
  while (start < frameMs.length && skipped < BENCH_WARMUP_MS) skipped += frameMs[start++] ?? 0;
  const ms = frameMs.slice(start).filter((t) => t > 0 && Number.isFinite(t));
  if (ms.length === 0) return { frames: 0, avgFps: 0, low1Fps: 0, slowShare: 0 };
  const total = ms.reduce((a, b) => a + b, 0);
  const sorted = [...ms].sort((a, b) => b - a);
  const worst = sorted.slice(0, Math.max(1, Math.ceil(ms.length * 0.01)));
  const worstAvg = worst.reduce((a, b) => a + b, 0) / worst.length;
  return {
    frames: ms.length,
    avgFps: Math.round((1000 * ms.length) / total),
    low1Fps: Math.round(1000 / worstAvg),
    slowShare: ms.filter((t) => t > 20).length / ms.length,
  };
}

/** Nome da placa de vídeo, quando o navegador informa. */
export function gpuName(gl: WebGLRenderingContext | WebGL2RenderingContext): string {
  const ext = gl.getExtension("WEBGL_debug_renderer_info");
  const name: unknown = ext ? gl.getParameter(ext.UNMASKED_RENDERER_WEBGL) : gl.getParameter(gl.RENDERER);
  return typeof name === "string" ? name : "desconhecida";
}
